import React, { Fragment } from 'react';
import { Card, Row, Col } from 'antd';
import StatCards from './components/StatCards';
import styled from 'styled-components';
import List from './components/List';
import ContainerBody from '@components/ContainerBody';
import Breadcrumb from '@components/Breadcrumb';
import { usePermission } from '@contexts/Auth/UsePermission';
import Page403 from '@page/Common/403/403';

const Customer = () => {
  const { customer } = usePermission();

  // Nếu không có quyền view, hiển thị trang 403
  if (!customer.view) {
    return (
      <ContainerBody>
        <Page403 />
      </ContainerBody>
    );
  }

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb
          homePath={'/dashboard'}
          routeSegments={[{ name: 'Quản lý khách hàng', path: '/customers' }]}
        />
      </div>
      <Row>
        <Col span={24}>
          <List />
        </Col>
      </Row>
    </ContainerBody>
  );
};

export default Customer;
